import { GET_BPT_PREFERENCE_ANALYSIS_ADRECALL_ASYNC } from './actions';

export const adRecallTabReducer = (state = null, action) => {
    switch (action.type) {
        case GET_BPT_PREFERENCE_ANALYSIS_ADRECALL_ASYNC.actions.SUCCEEDED:
            return action.payload;
        case GET_BPT_PREFERENCE_ANALYSIS_ADRECALL_ASYNC.actions.FAILED:
            return null;
        default:
            return state;
    }
};
